import React from 'react';
import { ZoomMtg } from '@zoomus/websdk';

const crypto = require('crypto') // crypto comes with Node.js

function generateSignature(apiKey, apiSecret, meetingNumber, role) {
  return new Promise((res, rej) => {

      const timestamp = new Date().getTime() - 30000
      const msg = Buffer.from(apiKey + meetingNumber + timestamp + role).toString('base64')
      const hash = crypto.createHmac('sha256', apiSecret).update(msg).digest('base64')
      const signature = Buffer.from(`${apiKey}.${meetingNumber}.${timestamp}.${role}.${hash}`).toString('base64')
    
      res(signature);
  })
   
}


var apiKey = 'bWr8qR8aR-ehfKPn3Ly4gQ';
var apiSecret = 'vp6ZPf7OLUx4d8aGQ3ZnjHU6Lyy0DzqzvyxE';
var meetingNumber = 92357766608;
var role = 0;
var leaveUrl = 'http://localhost:3000/video';
var userName = 'omprakash';
var userEmail = 'test@gmail.com';
var passWord = '6a5h65';
var signature = '';
// 'bWr8qR8aR-ehfKPn3Ly4gQ
generateSignature(apiKey, apiSecret, meetingNumber, 0).then((res) => {
    signature = res;
}).catch(e => console.log(e, "sada"))

const Zoom = () => {
    React.useEffect(() => {
        showDiv();
        ZoomMtg.setZoomJSLib('https://source.zoom.us/1.9.1/lib', '/av');
        ZoomMtg.preLoadWasm();
        ZoomMtg.prepareJssdk();
        initialMeeting();
    }, []);

    const initialMeeting = () => {
        ZoomMtg.init({
            leaveUrl: leaveUrl,
            isSupportAV: true,
            success: (success) => {
                console.log(success)

                ZoomMtg.join({
                    signature: signature,
                    meetingNumber: meetingNumber,
                    userName: userName,
                    apiKey: apiKey,
                    userEmail: userEmail,
                    passWord: passWord,
                    success: (success) => {
                        console.log(success)
                    },
                    error: (error) => {
                        console.log(error)
                    }
                })

            },
            error: (error) => {
                console.log(error)
            }
        })
    }
    const showDiv = () => {
        document.getElementById('zmmtg-root').style.display = 'block';
    }
    return (
        <div></div>
    )
}

export default Zoom;